import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Box from "@mui/material/Box";
import { IconButton, MenuItem, Select, FormControl, CircularProgress } from "@mui/material";
import Icon from "@mui/material/Icon";
import { useICCCColors } from "./theme";
import { TIME_RANGES } from "../model/constants";

const fmtTimestamp = (ms) =>
  ms
    ? new Date(ms).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
    : "Loading…";

export default function DashboardHeader({ lastUpdated, timeRange, onTimeRangeChange, onRefresh, isFetching }) {
  const ICCC_COLORS = useICCCColors();
  return (
    <MDBox
      sx={{
        bgcolor: ICCC_COLORS.cardBg,
        border: `1px solid ${ICCC_COLORS.cardBorder}`,
        borderRadius: 1.5,
        px: 2.5,
        py: 1.75,
        display: "flex",
        alignItems: "center",
        gap: 2,
        boxShadow: ICCC_COLORS.shadow,
      }}
    >
      <MDBox sx={{ flex: 1, minWidth: 0 }}>
        <MDTypography variant="h3" fontWeight="bold" sx={{ color: ICCC_COLORS.textPrimary, lineHeight: 1, fontSize: 30 }}>
          Coral ICCC
        </MDTypography>
        <MDTypography variant="body2" sx={{ color: ICCC_COLORS.textSecondary, mt: 0.25 }}>
          Device Health Dashboard
        </MDTypography>
      </MDBox>

      <MDBox display="flex" alignItems="center" gap={0.5}>
        <Icon sx={{ color: ICCC_COLORS.textMuted, fontSize: 18 }}>schedule</Icon>
        <MDTypography variant="caption" sx={{ color: ICCC_COLORS.textSecondary }}>
          Last Updated:{" "}
          <Box component="strong" sx={{ color: ICCC_COLORS.textPrimary, ml: 0.5 }}>
            {fmtTimestamp(lastUpdated)}
          </Box>
        </MDTypography>
        <IconButton
          size="small"
          onClick={onRefresh}
          title="Refresh now"
          aria-label="Refresh dashboard"
          sx={{ color: ICCC_COLORS.accent }}
        >
          {isFetching ? <CircularProgress size={16} sx={{ color: ICCC_COLORS.accent }} /> : <Icon fontSize="small">refresh</Icon>}
        </IconButton>
      </MDBox>

      <FormControl size="small" sx={{ minWidth: 150 }}>
        <Select
          value={timeRange}
          onChange={(e) => onTimeRangeChange?.(e.target.value)}
          displayEmpty
          aria-label="Time range"
          sx={{
            color: ICCC_COLORS.textPrimary,
            ".MuiOutlinedInput-notchedOutline": { borderColor: ICCC_COLORS.cardBorder },
            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: ICCC_COLORS.accent },
            ".MuiSvgIcon-root": { color: ICCC_COLORS.textSecondary },
          }}
          MenuProps={{ PaperProps: { sx: { bgcolor: ICCC_COLORS.cardBg2, color: ICCC_COLORS.textPrimary } } }}
        >
          {TIME_RANGES.map((r) => (
            <MenuItem key={r.value} value={r.value}>
              {r.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </MDBox>
  );
}

DashboardHeader.propTypes = {
  lastUpdated: PropTypes.number,
  timeRange: PropTypes.string,
  onTimeRangeChange: PropTypes.func,
  onRefresh: PropTypes.func,
  isFetching: PropTypes.bool,
};
